import { createAction } from '@reduxjs/toolkit';

export const showModal = createAction<{
  modalType: string;
  props?: any;
  config?: any;
}>('showModal');

export const updateModal = createAction<{
  modalType: string;
  props?: any;
  config?: any;
}>('updateModal');

export const hideModal = createAction<string>('hideModal');
